import {
  Alert,
  Button,
  Divider,
  Fab,
  Grid,
  IconButton,
  LinearProgress,
  Pagination,
  Skeleton,
  Snackbar,
  Stack,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import React, { useCallback, useState } from "react";
import FilterAltIcon from "@mui/icons-material/FilterAltOutlined";
import SalesReportList from "pages/reports/SalesReportList";
import { getReports } from "data/server_apis/reportService";
import { useEffect } from "react";
import SimpleBarHorizontal from "components/SimpleBarHorizontal";
import SalesFilterDrawer from "pages/reports/filter/SalesFilterDrawer";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import moment from "moment";
import { Refresh } from "@mui/icons-material";
import { dispatch } from "store";
import { getReportsThunk, getTotalForReportsThunk, orderSelector } from "store/reducers/order/OrderSlice";
import { useSelector } from "react-redux";
import useDownloader from "react-use-downloader";
import BottomDialog from "components/BottomDialog";
import CloseIcon from "@mui/icons-material/Close";
import { baseUrl } from "data/server_apis/server_api";

const filterStateInitial = {
  order_no: "",
  order_no__gt: "",
  order_no__lt: "",
  grant_total: "",
  grant_total__gt: "",
  grant_total__lt: "",
  payment: null,
  customer: null,
  vend_status: "",
  machine: "",
  qty: "",
  qty__gt: "",
  qty__lt: "",
  product: null,
  category: null,
  sub_category: null,
  // date_after: null,
  // date_before: null,
  date_iso_after: null,
  date_iso_before: null,
  order: "",
  location: "",
};
const SalesReport = () => {
  const [loading, setLoading] = React.useState(false);
  const [page, setPage] = React.useState(1);
  const [orderError, setError] = React.useState(false);
  const [openFilter, setOpenFilter] = React.useState(false);
  const [currentFilter, setCurrentFilter] = React.useState(null);

  const [filter, setFilter] = React.useState(filterStateInitial);
  const toggleDrawer = () => {
    setOpenFilter(false);
  };

  const getOrders = useCallback(async () => {
    // console.log("Getting page " + page);
    setLoading(true);
    setError(false);

    try {
      let resp;
      if (currentFilter) {
        dispatch(getTotalForReportsThunk(currentFilter));
        dispatch(getReportsThunk({ ...currentFilter, page: page }));
        
      } else {
        dispatch(getTotalForReportsThunk());
        dispatch(getReportsThunk({ page: page }));
      }
    } catch (error) {
      setError(true);
      console.log({ error });
    }
    setLoading(false);
  }, [currentFilter, page]);

  const handleChange = (event, value) => {
    setPage(value);
  };

  useEffect(() => {
    getOrders();
  }, [getOrders, page]);

  useEffect(() => {
    setPage(1);
  }, [currentFilter]);

  const onApplyFilter = () => {
    const _filter = {
      ...filter,
      order_no: filter.order_no ?? "",
      order_no__gt: filter.order_no__gt ?? "",
      order_no__lt: filter.order_no__lt ?? "",
      grant_total: filter.grant_total,
      payment: filter.payment?.id,
      product: filter.product?.id ?? "",
      machine: filter.machine?.id ?? "",
      category: filter.category?.id ?? "",
      hsn: filter.hsn?.HSNCODE ?? "",
      sub_category: filter.sub_category?.id ?? "",
      customer: filter.customer?.id ?? "",
      location: filter.location?.id ?? "",
      date_iso_after: moment(filter.date_iso_after).isValid()
        ? moment(filter.date_iso_after).toISOString()
        : "",
      date_iso_before: moment(filter.date_iso_before).isValid()
        ? moment(filter.date_iso_before).toISOString()
        : "",
    };
    // console.log(_filter);
    setCurrentFilter(_filter);
  };

  const clearFilters = () => {
    setFilter(filterStateInitial);
    setCurrentFilter(null);
  };

  const orderState = useSelector((state) => state.order);
  const token = useSelector((state) => state.auth?.user?.access);
  const [openDownload, setOpenDownload] = useState(false);

  const constructUrl = ({
    order_no = "",
    order_no__gt = "",
    order_no__lt = "",
    grant_total = "",
    grant_total__gt = "",
    grant_total__lt = "",
    payment = "",
    customer = "",
    machine = "",
    vend_status = "",
    qty = "",
    qty__gt = "",
    qty__lt = "",
    product = "",
    category = "",
    hsn = "",
    sub_category = "",
    date_iso_after = "",
    date_iso_before = "",
    location = "",
    order = "",
    page = 1,
  }) => {
    return `${baseUrl}/sales/order/export-to-csv?order_no=${order_no}&order_no__gt=${order_no__gt}&order_no__lt=${order_no__lt}&grant_total=${grant_total}&grant_total__gt=${grant_total__gt}&grant_total__lt=${grant_total__lt}&payment=${payment}&customer=${
      customer?.id ?? ""
    }&vend_status=${vend_status}&qty=${qty}&qty__gt=${qty__gt}&qty__lt=${qty__lt}&product=${product}&machine=${machine}&hsn=${hsn}&category=${category}&sub_category=${sub_category}&date_iso_after=${
      moment(filter.date_iso_after).isValid()
        ? moment(filter.date_iso_after).toISOString()
        : ""
    }&date_iso_before=${
      moment(filter.date_iso_before).isValid()
        ? moment(filter.date_iso_before).toISOString()
        : ""
    }&location=${location}&o=${order}`;
  };

  const {elapsed,  download, cancel, error, isInProgress } =
    useDownloader({
      mode: "cors",
      credentials: "include",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

  const startDownload = () => {
    setOpenDownload(true);
    const now = new Date();
    const timestamp = now.toISOString().replace(/[-:.]/g, "");
    const filename = `${timestamp}-export.csv`;
    download(constructUrl(filter), filename);
  };

  const state = useSelector((state) => state.order);
  const orders = useSelector(orderSelector.selectAll)

  return (
    <Box sx={{ padding: 2, flexGrow: 1, height: "100%", display: "flex" }}>
      <Stack direction="column" flexGrow={1}>
        <Stack direction="row" justifyContent="center" alignItems="center">
          <Button
            startIcon={<FileDownloadIcon />}
            variant="outlined"
            onClick={startDownload}
            sx={{ mr: "auto" }}
          >
            Export CSV
          </Button>
          <Stack direction="row" sx={{ ml: "auto", mr: "auto" }}>
            <Typography variant="h5" color="text.secondary">
              Total amount :
            </Typography>
            {orderState.loading ? (
              <Skeleton animation="wave" width={100} sx={{ ml: 1 }} inline />
            ) : (
              <Typography variant="h5" color="text.secondary" sx={{ ml: 1 }}>
                {orderState.data?.total_sales.toLocaleString('en-IN', {minimumFractionDigits: 2})} Rs
              </Typography>
            )}

            <Typography variant="h5" color="text.secondary" sx={{ ml: 3 }}>
              Total items sold :
            </Typography>
            {orderState.loading ? (
              <Skeleton animation="wave" width={100} sx={{ ml: 1 }} inline />
            ) : (
              <Typography variant="h5" color="text.secondary" sx={{ ml: 1 }}>
                {orderState.data?.total_qty.toLocaleString('en-IN')} Nos
              </Typography>
            )}
          </Stack>
          <Button
            startIcon={<FilterAltIcon />}
            variant="outlined"
            onClick={() => setOpenFilter(true)}
            sx={{ ml: "auto" }}
          >
            Show filters
          </Button>
        </Stack>

        <Box sx={{ flexGrow: 1 }} marginY={1}>
          <SimpleBarHorizontal>
            <SalesReportList loading={loading} orders={orders} />
          </SimpleBarHorizontal>
        </Box>
        <Stack direction="row" justifyContent="center" sx={{ position: "relative" }}>
          <Box sx={{ display: "flex" }} position={"absolute"} left={0} top={0} zIndex={1}>
            <Stack direction="row" spacing={2}>
              <Box
                sx={{
                  width: 20,
                  height: 20,
                  borderRadius: "50%",
                  backgroundColor: "black",
                }}
              />
              <Typography variant="body2">Success</Typography>
              <Box
                sx={{
                  width: 20,
                  height: 20,
                  borderRadius: "50%",
                  backgroundColor: "blue",
                }}
              />
              <Typography variant="body2">Waiting</Typography>
              <Box
                sx={{
                  width: 20,
                  height: 20,
                  borderRadius: "50%",
                  backgroundColor: "#faad14",
                }}
              />
              <Typography variant="body2">Failed</Typography>
            </Stack>
          </Box>
          <Pagination
            count={state?.total_pages}
            variant="outlined"
            shape="rounded"
            onChange={handleChange}
          />
        </Stack>
      </Stack>
      <Snackbar
        open={orderError}
        autoHideDuration={6000}
        onClose={() => setError(false)}
        action={
          <Button color="inherit" size="small" onClick={getOrders}>
            Retry
          </Button>
        }
      >
        <Alert
          onClose={() => setError(false)}
          severity="success"
          sx={{ paddingX: 5 }}
        >
          Error fetching sales report !
        </Alert>
      </Snackbar>
      <SalesFilterDrawer
        open={openFilter}
        toggleDrawer={toggleDrawer}
        filter={filter}
        setFilter={setFilter}
        onApplyFilter={onApplyFilter}
        clearFilters={clearFilters}
      />
      <Fab
        sx={{
          margin: 0,
          top: "auto",
          right: { xs: 40, sm: 30, md: 50, lg: 70, xl: 70 },
          bottom: 30,
          left: "auto",
          position: "fixed",
        }}
        size="medium"
        color="primary"
        onClick={getOrders}
      >
        <Refresh />
      </Fab>
      <BottomDialog
        open={isInProgress}
        onClose={() => {
          setOpenDownload(false);
        }}
      >
        <Stack direction="column">
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography variant="h5" sx={{ ml: 2 }}>
              Downloading invoice
            </Typography>
            <IconButton
              onClick={() => {
                setOpenDownload(false);
              }}
            >
              <CloseIcon />
            </IconButton>
          </Stack>
          <Divider />
          <Box sx={{ m: 2 }}>
            <LinearProgress />
          </Box>
          <Typography variant="caption" sx={{ mx: 2 }}>
            Time elapsed: {elapsed} Seconds
          </Typography>
          <Stack direction="row">
            <Box sx={{ ml: 2, mb: 1 }}>
              <Button
                variant="outlined"
                size="small"
                color="error"
                onClick={cancel}
              >
                Cancel download
              </Button>
            </Box>
            {error && (
              <Typography variant="subtitle1" color="red">
                Error occurred
              </Typography>
            )}
          </Stack>
        </Stack>
      </BottomDialog>
    </Box>
  );
};

export default SalesReport;
